import type { PowerAvailabilityPreferences, ProjectIntent } from '../../types/siteRag';

/** A declared grid connection takes precedence over a conflicting campus label. */
export function intentHasDeclaredGridConnection(intent: Pick<ProjectIntent, 'phases'> | null | undefined): boolean {
  return (intent?.phases ?? []).some(phase => {
    const config = phase.powerSourceConfig;
    return config?.gridConnection === 'grid-connected'
      || (config?.components ?? []).includes('grid')
      || (!config?.components?.length && phase.powerSource === 'grid');
  });
}

/** Explicit planned topology, never inferred from BTM or an absent grid source. */
export function isFullyIslandedIntent(
  intent: ProjectIntent | null | undefined,
  strategy?: PowerAvailabilityPreferences['btmStrategy'] | null,
): boolean {
  if (intentHasDeclaredGridConnection(intent)) return false;
  if (strategy === 'grid-only' || strategy === 'hybrid') return false;
  if (strategy === 'islanded') return true;
  const phases = intent?.phases ?? [];
  return phases.length > 0 && phases.every(phase => phase.powerSourceConfig?.gridConnection === 'islanded');
}
